"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiButton = void 0;
var global_1 = require("../../global");
var colors_1 = require("../../generated/colors");
var shape_1 = require("../../global/shape");
exports.MuiButton = {
    styleOverrides: {
        root: {
            fontSize: "1.1875rem",
            padding: "0.25rem 2.5rem",
            height: "auto",
            textTransform: "none",
            fontWeight: global_1.fontWeight.bold,
            transition: "all .25s ease-out",
            borderRadius: shape_1.borderRadius.button,
            textAlign: "left",
        },
        startIcon: {
            marginRight: "1rem",
            width: "1.5rem",
            height: "1.5rem",
        },
    },
    variants: [
        // Size
        {
            props: {
                size: "small",
            },
            style: {
                height: "2rem",
                fontSize: ".9rem",
                padding: "0 1.5rem",
            },
        },
        // Variants
        {
            props: {
                variant: "cta",
            },
            style: {
                color: colors_1.colors.White,
                backgroundColor: colors_1.colors.Primary,
                boxShadow: "inset 0 0 0 0 transparent, 0 0 0 0 transparent",
                "&:hover": {
                    backgroundColor: colors_1.colors.Primary,
                    boxShadow: "inset 0 0 0 0 transparent, 0 0 0 2px " + colors_1.colors.Primary,
                },
            },
        },
        {
            props: {
                variant: "default",
            },
            style: {
                color: colors_1.colors.Grey1,
                backgroundColor: "transparent",
                boxShadow: "inset 0 0 0 2px " + colors_1.colors.Grey1 + ", 0 0 0 0 " + colors_1.colors.Primary,
                "&:hover": {
                    backgroundColor: "transparent",
                    boxShadow: "inset 0 0 0 0 " + colors_1.colors.Primary + ", 0 0 0 2px " + colors_1.colors.Primary,
                },
            },
        },
        {
            props: {
                variant: "secondary",
            },
            style: {
                color: colors_1.colors.White,
                backgroundColor: colors_1.colors.Grey1,
                boxShadow: "inset 0 0 0 0 transparent, 0 0 0 0 transparent",
                "&:hover": {
                    color: colors_1.colors.White,
                    backgroundColor: colors_1.colors.Grey1,
                    boxShadow: "inset 0 0 0 0 transparent, 0 0 0 2px " + colors_1.colors.Grey1,
                },
            },
        },
        {
            props: {
                variant: "tertiary",
            },
            style: {
                color: colors_1.colors.Grey1,
                padding: "0",
                backgroundColor: "transparent",
                "&:hover": {
                    color: colors_1.colors.Primary,
                    backgroundColor: "transparent",
                },
            },
        },
        // Dark Mode
        {
            props: {
                variant: "default",
                color: "light",
            },
            style: {
                color: colors_1.colors.White,
                boxShadow: "inset 0 0 0 2px " + colors_1.colors.White + ", 0 0 0 0 " + colors_1.colors.Primary,
            },
        },
        {
            props: {
                variant: "secondary",
                color: "light",
            },
            style: {
                color: colors_1.colors.Grey1,
                backgroundColor: colors_1.colors.White,
                "&:hover": {
                    color: colors_1.colors.Grey1,
                    backgroundColor: colors_1.colors.White,
                    boxShadow: "inset 0 0 0 0 transparent, 0 0 0 2px " + colors_1.colors.White,
                },
            },
        },
        {
            props: {
                variant: "tertiary",
                color: "light",
            },
            style: {
                color: colors_1.colors.White,
            },
        },
    ],
};
//# sourceMappingURL=button.js.map